import {
	createSlice,
	createAsyncThunk,
	createEntityAdapter,
} from "@reduxjs/toolkit";
import axios from "axios";
import CONFIG from "app/config";
import {
	query,
	mutation,
} from "app/main/apps/residence-hall/graphql/tenant_graphql";
import { showMessage } from "app/store/fuse/messageSlice";
import uploadSvc from "app/services/upload";
import randomString from "app/services/randomString";
import { mutation as mutationUpload } from "app/graphql/upload_graphql";

export const getTenantsListView = createAsyncThunk(
	"residenceHallApp/tenant-list-view/getTenantsListView",
	async (params) => {
		const response = await axios.post(CONFIG.API + "/api/", {
			query: query.list,
            variables: params
		});
		var data = response.data.data.tenantsList;

		return data;
	}
);

export const getTenantByID = createAsyncThunk(
    "residenceHallApp/tenant-list-view/getTenantByID",
    async (params) => {
        const response = await axios.post(CONFIG.API + "/api/", {
            query: query.getTenantByID,
            variables: params,
        });

        if (response.data.data.tenantById) {
            var data = response.data.data.tenantById;
            return data === undefined ? null : data;
        }
    }
);

export const resendTenant = createAsyncThunk(
    "residenceHallApp/tenant-list-view/resendTenant",
    async (form) => {
        const response = await axios.post(CONFIG.API + "/api/", {
            query: mutation.resendTenant,
            variables: {
                data: JSON.stringify(form)
            },
        });

        if (response.data.data.resendTenant) {
            var data = response.data.data.resendTenant;
            return data === undefined ? null : data;
        }
    }
);

export const removeTenantsListView = createAsyncThunk(
	"residenceHallApp/tenant-list-view/removeTenantsListView",
	async (tenantsIds, { dispatch, getState }) => {

		await tenantsIds.map(async (id) => {
			await axios.post(CONFIG.API + "/api/", {
				query: mutation.delete,
				variables: {
					id: id,
				},
			});
		});

		dispatch(
			showMessage({
				message: "Room(s) has been successfully deleted.",
				autoHideDuration: 5000, //ms
				anchorOrigin: {
					vertical: "bottom",
					horizontal: "right",
				},
				variant: "success",
			})
		);

		return tenantsIds;
	}
);

const uploadImages = (uploadData, tenantsData, image) => {

    return new Promise(async (resolve, reject) => {

        const response = await axios.post(CONFIG.API + "/api/", {
            query: mutationUpload.create,
            variables: {
                data: JSON.stringify(uploadData),
            },
        });

        if (response.data.data.createUpload.status == "success") {
            var upload = response.data.data.createUpload.upload;

            if (tenantsData.tenantsPicId == image.image.id) {
                tenantsData.tenantsPicPath = upload.path;
            }

            tenantsData.images[image.index].upload_id = upload.id;
            tenantsData.images[image.index].file_name = upload.fileName;
            tenantsData.images[image.index].file_id = upload.fileId;
            tenantsData.images[image.index].file_type = upload.fileType;
            tenantsData.images[image.index].path = upload.path;
            tenantsData.images[image.index].module = upload.module;
            tenantsData.images[image.index].url = "";

            resolve(tenantsData);

        }

    });

}

const saveImages = (tenantsData) => {

    return new Promise(async (resolve, reject) => {

        if (tenantsData.images.length) {

            var newImages = [];

            tenantsData.images.map(async (image, index) => {

                if (image.status === "new") {
                    newImages.push({
                        index: index,
                        image: image
                    })
                } else {
                    if (tenantsData.tenantsPicId == image.fileId) {
                        tenantsData.tenantsPicPath = image.path;
                    }
                }

            });

            if (newImages.length) {

                var tempCount = 0;

                newImages.map(async (image, index) => {

                    await uploadSvc({
                        file: image.image.file,
                        destination_file_name: "residence-hall/tenants/tenants-" + randomString() + "-" + (image.image.file ? image.image.file.name : image.image.fileName)
                    }).then(async (result) => {

                        if (result.status === 200 && result.data.status === "success") {

                            var uploadData = result.data.uploadData
                            uploadData['module'] = 'residence-hall-tenants';
                            uploadData['file_id'] = image.image.id;

                            await uploadImages(uploadData, tenantsData, image).then(async (tenantsData) => {

                                if (tenantsData) {
                                    tempCount++;
                                    if (newImages.length == tempCount) {
                                        resolve(tenantsData);
                                    }
                                }

                            });
                        }


                    });

                });

            } else {
                resolve(tenantsData)
            }


        } else {

            resolve(tenantsData);

        }

    });

}

export const saveTenantListView = createAsyncThunk(
    "residenceHallApp/tenant-list-view/saveTenantListView",
    async (tenantsData, { dispatch, getState }) => {

        tenantsData.tenantsAmenities = (tenantsData.tenantsAmenities ? JSON.stringify(tenantsData.tenantsAmenities) : '');

        return await saveImages(tenantsData).then(async (tenantsData) => {

            const response = await axios.post(CONFIG.API + "/api/", {
                query: mutation.save,
                variables: {
                    data: JSON.stringify(tenantsData),
                    id: tenantsData?.id,
                },
            });

            dispatch(
                showMessage({
                    message: response.data.data.saveTenantListView.message,
                    autoHideDuration: 5000, //ms
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "right",
                    },
                    variant: response.data.data.saveTenantListView.status
                })
            );
            return response.data.data.saveTenantListView;

        });

    });

const tenantsAdapter = createEntityAdapter({});

export const {
	selectAll: selectTenantsListView,
	selectById: selectTenantsListViewById,
} = tenantsAdapter.getSelectors((state) => state.residenceHallApp.tenantsListView);

const tenantsSlice = createSlice({
	name: "residenceHallApp/tenant-list-view",
	initialState: tenantsAdapter.getInitialState({
		searchText: "",
		showModal: false,
	}),
	reducers: {
		setTenantsListViewSearchText: {
			reducer: (state, action) => {
				state.searchText = action.payload;
			},
			prepare: (event) => ({ payload: event.target.value || "" }),
		},
	},
	extraReducers: {
		[getTenantsListView.fulfilled]: tenantsAdapter.setAll,
		[removeTenantsListView.fulfilled]: (state, action) =>
			tenantsAdapter.removeMany(state, action.payload),
		[saveTenantListView.fulfilled]: (state, action) => action.payload,
	},
});

export const { setTenantsListViewSearchText } = tenantsSlice.actions;

export default tenantsSlice.reducer;
